import { storyblokEditable } from "@storyblok/react";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { CollectionCardGrid } from "./CollectionCardGrid";
import { CategoryBannerStoryblok } from "@/types/sb-component-types";
import { Container } from "@/components/layout/container";
export const CategoryBanner = ({
  blok
}: {
  blok: CategoryBannerStoryblok;
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: 0.3
  });
  return <motion.section ref={ref} {...storyblokEditable(blok)} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 50
  }} className="overflow-x-hidden bg-white py-8 sm:py-12 md:py-16" initial={{
    opacity: 0,
    y: 50
  }} transition={{
    duration: 0.5
  }} data-sentry-element="unknown" data-sentry-component="CategoryBanner" data-sentry-source-file="index.tsx">
      <Container className="px-4 sm:px-6 lg:px-8" data-sentry-element="Container" data-sentry-source-file="index.tsx">
        <motion.div animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} className="mb-8 sm:mb-10 md:mb-12" initial={{
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
          <h2 className="mb-2 text-2xl font-bold sm:mb-3 sm:text-3xl md:mb-4 md:text-4xl">
            {blok.title}
          </h2>
          {blok.subtitle && <p className="max-w-2xl text-base text-slate-600 sm:text-lg">
              {blok.subtitle}
            </p>}
        </motion.div>
        <motion.div animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} initial={{
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
          <CollectionCardGrid data-sentry-element="CollectionCardGrid" data-sentry-source-file="index.tsx" />
        </motion.div>
      </Container>
    </motion.section>;
};